var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaximiseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.44444 12.0556H3.11111V12.5H0.5V9.88889H0.944444V11.5556V12.0556H1.44444ZM12.0556 11.5556V9.88889H12.5V12.5H9.88889V12.0556H11.5556H12.0556V11.5556ZM0.944444 1.44444V3.11111H0.5V0.5H3.11111V0.944444H1.44444H0.944444V1.44444ZM11.5556 0.944444H9.88889V0.5H12.5V3.11111H12.0556V1.44444V0.944444H11.5556Z",
    fill: "#5B6B79",
    stroke: "#426CFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximiseIcon);
export default __webpack_public_path__ + "static/media/maximise-icon.7b06992b27f05c618acbb625ad8bf7d5.svg";
export { ForwardRef as ReactComponent };